import { render, staticRenderFns } from "./authoritySet.vue?vue&type=template&id=9965d00c&scoped=true&"
import script from "./authoritySet.vue?vue&type=script&lang=ts&"
export * from "./authoritySet.vue?vue&type=script&lang=ts&"
import style0 from "./authoritySet.vue?vue&type=style&index=0&id=9965d00c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9965d00c",
  null
  
)

export default component.exports